import { i18n } from '@/core';
import moment from 'moment';

function get() {
	let locale  = localStorage.getItem('locale') || 'no';
	updateLocale(locale);
	return locale;
}

function set(locale) {
	localStorage.setItem('locale', locale);
	updateLocale(locale);
}

function updateLocale(locale) {
	if (locale === 'no') {
		moment.locale('nb');
	} else {
		moment.locale(locale);
	}
	i18n.locale = locale;
}

export default {
	get,
	set,
};